module.exports = __webpack_public_path__ + "img/footer-mask.5b1415ab.png";